import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { registerServiceWorker } from './pwa.ts';
import { startAppearance } from './state/appearance.ts';
import { startPrintSupport } from './lib/print.ts';
import { startOutbox } from './state/outbox.ts';
import './styles.css';

startAppearance();
startPrintSupport();

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Der Wurzelknoten #root fehlt in index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
startOutbox();
